module.exports = __webpack_public_path__ + "img/customers.cab447ae.png";